const CREATE = "create";
const EDIT = "edit";
const DELETE = "delete";
const VIEW = "view";
const LIST = "list";

export default { CREATE, EDIT, DELETE, VIEW, LIST };
